import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import Themes from '../Themes';

function LiveTentative({ xTopStyle, xBottomStyle, hero, theme, tentative, fontP }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: '-50% 0px -50% 0px' });

  const Components = Themes[theme];
  const aturCaraMajlis = JSON.parse(tentative);

  const heroStyle = {
    backgroundImage: `url(${Components.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  return (
    <div
      ref={ref}
      className="min-h-screen relative flex items-center justify-center overflow-hidden"
      style={heroStyle}
    >
      {/* Main Schedule Content */}
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 2, ease: 'easeInOut' }}
        className="text-center z-10 my-20"
      >
        <div className={Components.tStyle}>
          <h1 className={`text-l mb-8 uppercase font-bold ${fontP}`}>Schedule</h1>
          {aturCaraMajlis.map((item, index) => (
            <div key={index} className={`my-4 ${fontP}`}>
              <p className="text-l">{item.title}:</p>
              <p className="text-l">{item.displaytime}</p>
            </div>
          ))}
        </div>
      </motion.div>

      {/* Foreground Top Image */}
      <motion.img
        src={Components.ft}
        initial={{ opacity: 0, x: xTopStyle, scale: 1.2 }}
        animate={
          isInView
            ? { opacity: 1, x: 0, scale: 1 }
            : { opacity: 0, x: xTopStyle, scale: 1.2 }
        }
        transition={{ duration: 2, ease: 'easeInOut' }}
        className={Components.ftStyle}
      />

      {/* Foreground Bottom Image */}
      <motion.img
        src={Components.fb}
        initial={{ opacity: 0, x: xBottomStyle, scale: 1.2 }}
        animate={
          isInView
            ? { opacity: 1, x: 0, scale: 1 }
            : { opacity: 0, x: xBottomStyle, scale: 1.2 }
        }
        transition={{ duration: 2, ease: 'easeInOut' }}
        className={Components.fbStyle}
      />
    </div>
  );
}

export default LiveTentative;
